import { PLACE_FIELD_NAME_LIST } from '@web-platform/shared-universal-constants/src/places';
import get from 'lodash/get';

import type { PlacesResponseBody } from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarExplore';
import type {
  RadarResponsePayload,
  RadarResponsePayloadError,
  RadarResponsePayloadSuccess,
} from '@web-platform/shared-universal-types/src/network/endpoints/radar/radarResponsePayloadTypes';
import type {
  KeysOfUnion,
  Maybe,
  ValuesByKeysOfUnionObject,
} from '@web-platform/shared-universal-types-utils/src/utils';

export const isPlacesResponseError = (
  response: RadarResponsePayload,
): response is RadarResponsePayloadError =>
  !!response.error ||
  !PLACE_FIELD_NAME_LIST.reduce(
    (hasValidPlaceField, curPlaceField) =>
      hasValidPlaceField || !!get(response.body || {}, curPlaceField),
    false,
  );

export const getPlacesResponseBody = (
  response: RadarResponsePayloadSuccess,
): Maybe<PlacesResponseBody> => {
  if (!response.error && !!response.body) {
    return response.body;
  }
  return null;
};

export const getValueOfUnion = <T extends object, K extends KeysOfUnion<T>>(
  union: T,
  key: K,
): ValuesByKeysOfUnionObject<T, K> =>
  // @ts-expect-error - TS cannot verify union key access resolves to ValuesByKeysOfUnionObject
  union[key];
